import { Theme } from "@mui/material/styles";
import { alpha, SystemStyleObject } from "@mui/system";

import { resetContainerPaddings } from "utils/styles";

const opportunitiesSectionStyles = {
  container: (): SystemStyleObject<Theme> => ({
    mx: resetContainerPaddings,
    backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/opportunities/smoke.png)`,
    backgroundSize: { xs: "90% 124%", md: "60% 120%" },
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    position: "relative",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }),
  contentOuter: (theme: Theme): SystemStyleObject<Theme> => ({
    width: "100%",
    backgroundImage: `linear-gradient(0deg, ${alpha(
      theme.palette.background.default,
      0.9,
    )}, transparent), url(${
      process.env.NEXT_PUBLIC_CLOUDFRONT_URL
    }/pages/nfcTagsPage/common/grid.png)`,
    backgroundSize: "100% 100%, 100% 85%",
    backgroundPosition: "center center, center bottom",
    backgroundRepeat: "no-repeat",
    position: "relative",
  }),
  content: (): SystemStyleObject<Theme> => ({
    display: "grid",
    width: "100%",
    height: "100%",
  }),
  itemBox: (): SystemStyleObject<Theme> => ({
    display: "grid",
    alignContent: "center",
    gridColumn: 1,
    gridRow: 1,
  }),
  item: (): SystemStyleObject<Theme> => ({
    display: "grid",
    position: "relative",
  }),
  textSpace: (): SystemStyleObject<Theme> => ({
    mx: { xs: 1, md: 2, xl: 4 },
  }),
  text: (theme: Theme): SystemStyleObject<Theme> => ({
    textTransform: "uppercase",
    lineHeight: 1.5,
    fontWeight: 800,
    textAlign: "center",
    color: theme.palette.secondary.main,
    alignSelf: "center",
    mb: { xs: 5, md: 10 },
    fontSize: { xs: 16, sm: 24, md: 32, lg: 40, xl: 50 },

    WebkitTextStrokeColor: theme.palette.secondary.main,
    textStrokeColor: theme.palette.secondary.main,

    WebkitTextStrokeWidth: { xs: 0.8, md: 1.6 },
    textStrokeWidth: { xs: 0.8, md: 1.6 },
  }),
  strokeText: (theme: Theme): SystemStyleObject<Theme> => ({
    color: "transparent",

    WebkitTextStrokeColor: theme.palette.secondary.main,
    textStrokeColor: theme.palette.secondary.main,

    position: "relative",

    WebkitTextStrokeWidth: { xs: 0.8, md: 1.6 },
    textStrokeWidth: { xs: 0.8, md: 1.6 },
  }),
  overflowText: (): SystemStyleObject<Theme> => ({
    clipPath: "polygon(50% -90%, 70% 100%, 30% 100%)",
    gridColumn: 1,
    gridRow: 1,
  }),
};

export default opportunitiesSectionStyles;
